///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2023, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2021 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

export function loadScript(url: string) {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = url;
    script.async = true;
    script.onload = () => resolve(script);
    script.onerror = () => {
      script.remove();
      reject(new Error(`GET ${url} failed to load script`));
    };
    document.body.appendChild(script);
  });
}

export const memoize = (f) => {
  const cache = {};
  return (...args) => {
    const argStr = JSON.stringify(args);
    cache[argStr] = cache[argStr] || f(...args);
    return cache[argStr];
  };
};

function loadVisuazlizeJsScript(url) {
  if (window["getVisualizeLibInst"]) {
    const script = window["getVisualizeLibInst"].script;
    if (script) {
      if (script.src === url) return Promise.resolve(script);
      script.remove();
    }
    delete window["getVisualizeLibInst"];
  }
  return loadScript(url);
}

export const loadVisualizeJs = (url: string, onprogress) => {
  return loadVisuazlizeJsScript(url).then((script) => {
    return new Promise((resolve, reject) => {
      const instance = window["getVisualizeLibInst"]({
        urlMemFile: url + ".wasm",
        TOTAL_MEMORY: 134217728,
        onprogress,
      });
      instance["loadWasmError"] = reject;
      instance.postRun.push(() => {
        window["getVisualizeLibInst"].script = script;
        resolve(instance);
      });
    });
  });
};
